(() => {
  const initializeIncubation = (root) => {
    if (!root || root.dataset.interestReady === 'true') return;

    const projectSelect = root.querySelector('[data-project-interest-select]');
    const projectIdInput = root.querySelector('[data-project-interest-id]');
    const projectHeading = root.querySelector('[data-project-interest-heading]');
    if (!projectSelect || !projectIdInput || !projectHeading) return;

    const selectProject = (projectId) => {
      const projectOption = Array.from(projectSelect.options).find(
        (option) => option.dataset.projectId === projectId
      );
      if (!projectOption) return;

      projectSelect.value = projectOption.value;
      projectIdInput.value = projectOption.dataset.projectId;
      projectHeading.textContent = window.oieffurT('support_this', null, projectOption.textContent.trim());
    };

    root.querySelectorAll('[data-project-interest-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => selectProject(trigger.dataset.projectId));
    });

    projectSelect.addEventListener('change', () => {
      const selectedOption = projectSelect.options[projectSelect.selectedIndex];
      projectIdInput.value = selectedOption.dataset.projectId || '';
      projectHeading.textContent = window.oieffurT('support_this', null, selectedOption.textContent.trim());
    });

    const initialOption = projectSelect.options[projectSelect.selectedIndex];
    if (initialOption) projectIdInput.value = initialOption.dataset.projectId || '';
    root.dataset.interestReady = 'true';
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('.oieffur-incubation').forEach(initializeIncubation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
